import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import type React from "react";

const StyledTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "center",
  },
});

type Props = {
  value: Moment;
  onChange: (date: Moment | null) => void;
};

export const StartFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <DatePicker
      label="Start"
      format="MM/DD/YYYY"
      value={value}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      slots={{
        textField: (params) => <StyledTextField {...params} fullWidth />,
      }}
    />
  );
};

export const EndFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <DatePicker
      label="End"
      format="MM/DD/YYYY"
      value={value}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      slots={{
        textField: (params) => <StyledTextField {...params} fullWidth />,
      }}
    />
  );
};
